/**
 * This method returns if the current device is touchable
 * @returns if the current device is touchable
 */
function isTouchableDevice() {
    return ('ontouchstart' in window || navigator.maxTouchPoints > 0);
}
export { isTouchableDevice, };
//# sourceMappingURL=is-touchable-device.js.map